import api from "@/services/api";

export default {
  create(params) {
    return api().post("user/order/create", params);
  },
  list(params) {
    return api().post("user/order/list", params);
  },
  get(params) {
    return api().get("user/order/get/" + params.id);
  },
  checkOrder(input) {
    return api().get("user/order/checkIncompleteOrder"+"?order_complete_pending=" + input);
  },
  getResult(params) {
    return api().get("user/order/get-results/" + params.id);
  },
  check3MonthOrders() {
    return api().post("user/order/check3MonthOrders");
  },
  updateProgramCode(params){
    return api().post("update-program-code", params);
  }
};
